module.exports = __webpack_public_path__ + "img/t5-purple.e4c0d8ce.png";